import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { FinaliseShipmentResult } from '../../core/api/lab.types';

export const finaliseShipmentHasErrorSelector = (state: RootState): any =>
  state.finaliseShipment.errors && state.finaliseShipment.errors
    ? { hasError: true, message: state.finaliseShipment.errors[0].message }
    : { hasError: false };

export const finaliseShipmentIsBusySelector = (state: RootState): boolean =>
  state.finaliseShipment.status === StoreStatus.BUSY;

export const finaliseShipmentResponseSelector = (state: RootState): FinaliseShipmentResult | null =>
  state.finaliseShipment.response || null;
